module.exports = __webpack_public_path__ + "static/media/daedong-story-04.08178d19.jpg";